module.exports = __webpack_public_path__ + "static/img/s16.6466ef84.png";